import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { RseQuestion, RseQuestionIndex,SupplierDocument, SupplierRseAnswer, SupplierRseAnswersIndex} from '../../../../all-models';
import { 
  SharedDataService,
  DocumentsService
 } from  '../../../../all-services';
import { Subscription } from 'rxjs';
import { saveAs } from '@progress/kendo-file-saver';
import { SupplierRseAnswers } from '../SupplierRseAnswers';
import { ControlContainer, NgForm } from '@angular/forms';
import moment from 'moment';
@Component({
  selector: 'app-supplier-rse-answer-idx',
  templateUrl: './supplier-rse-answer-idx.component.html',
  styleUrls: ['./supplier-rse-answer-idx.component.scss'],
  viewProviders:[{ provide: ControlContainer, useExisting: NgForm }]
})
export class SupplierRseAnswerIdxComponent implements OnInit, OnChanges {

  
  @Input() frmRse: NgForm;
  constructor(
    public sharedDatasSvc: SharedDataService, 
    public docsSvc: DocumentsService
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.rseQuestionIndex && this.rseQuestionIndex.IndexType=='doc' && !!this.answerIdx.Value && !this.supplierDoc) {
      this.docsSvc.getSupplierDocuments(this.answer.SupplierId, parseInt(this.answerIdx.Value))
      .subscribe({
        next:values=> {
          if (values.length>0){
            values.sortObjectDesc('Id');
            this.supplierDoc = values[0];
          }
        }
      });
    }
  }


  @Input() supplierAnswsers!:SupplierRseAnswers;
  @Input() answerIdx!: SupplierRseAnswersIndex;
  @Input() answer!: SupplierRseAnswer;
  @Input() readonly: boolean = true;
  @Output() valueChanged = new EventEmitter<void>();


  @ViewChild('fileUpload') fileUpload: ElementRef;
  @ViewChild('inputControl') inputControl: ElementRef;

  onValueChanged():void {
    this.valueChanged.emit();
  } 
  
get rseQuestion():RseQuestion | undefined {
  if (!this.answer || !this.supplierAnswsers) return undefined;
  return this.supplierAnswsers.rseQuestions.find(q=>q.Id==this.answer.QuestionId);
}

  get rseQuestionIndex(): RseQuestionIndex | undefined {
    if (!this.rseQuestion|| !this.answerIdx)  return undefined;
    return this.rseQuestion.RseQuestionIndexes.find(qi=>qi.Id==this.answerIdx.IndexId);
  }

  get dateValue() : Date | undefined {
    if (this.rseQuestionIndex?.IndexType != 'date') return undefined;
    if (!this.answerIdx || !this.answerIdx.Value) return undefined;
    var regEx = /([12]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]))/;
    if (!this.answerIdx.Value.match(regEx)) return undefined;
    return moment(this.answerIdx.Value,'YYYY/MM/DD').toDate();
  }

  set dateValue(value:Date | undefined) {
    if (this.rseQuestionIndex?.IndexType == 'date'){
      this.answerIdx.Value = value == null ? undefined : moment(value).format('YYYY/MM/DD');
    }
  }

  datePickerOptions = {
    parseFormats: ["yyyy/MM/dd"]
  };

  supplierDoc?:SupplierDocument = undefined;

  get docFilename():string | undefined{
    if (this.pendingFile) return this.pendingFile.name;
    if (!this.supplierDoc?.FullPath) return undefined;
    return this.supplierDoc.FullPath.split('\\')[this.supplierDoc.FullPath.split('\\').length-1];
  }

  downloadDbFile():void {
    if (this.pendingFile) {
      var blob = new Blob([this.pendingFile]);
      saveAs(blob, this.docFilename);
      return;
    }
    if (this.supplierDoc?.FullPath) {
      this.sharedDatasSvc.WindowLock();
      this.docsSvc.downloadFile(this.supplierDoc.SupplierId,this.supplierDoc.Id).subscribe({
      next:blob=>{
        this.sharedDatasSvc.WindowUnlock();
        saveAs(blob, this.docFilename);
      },
      error:(reason) => this.sharedDatasSvc.alert("Erreur de téléchargement du fichier")
    });      
    }
  }

  get pendingFile():File | undefined {
    if (!this.supplierAnswsers && !this.answerIdx) return undefined;
    if (!this.supplierAnswsers.PendingFiles[this.answerIdx.IndexId]) return undefined;
    return this.supplierAnswsers.PendingFiles[this.answerIdx.IndexId];
  }
  
  set pendingFile(value:File | undefined) {
    if (this.supplierAnswsers && this.answerIdx) {
      this.supplierAnswsers.PendingFiles[this.answerIdx.IndexId] = value;
    }
  }

  ngOnInit(): void {

  }

  get inputName():string {
    if (!this.rseQuestionIndex) return '';
    return 'answerIdx_'+ this.rseQuestionIndex.Id.toString()
  }

  iSExtensionAllowed(filename:string):boolean{
    let ext= ('.'+ filename.split('.')[filename.split('.').length-1]).toUpperCase();
    return this.sharedDatasSvc.allowedExtensions.some(e=>e==ext);
  }
  
  isSizeAllowed(file: File): boolean{
    return file.size<=this.sharedDatasSvc.maxFileSize;
  }

  
  uploadProgress: number = null;
  uploadSub: Subscription;

  private fileIsDropping: boolean = false;
  onFilesDropped(event:any):void{
    this.pendingFile = undefined;
    let files:FileList=<FileList>event;
    const file: File = files[0];
    if (file) {
      if (!this.iSExtensionAllowed(file.name)) {
        this.sharedDatasSvc.pafAlert('Extension_non_autorisee');
        this.fileUpload.nativeElement.value = "";
          return;
      }
      if (!this.isSizeAllowed(file)) {
          this.sharedDatasSvc.pafAlert('Fichier_trop_volumineux');
          this.fileUpload.nativeElement.value = "";
          return;
      }
      if (this.fileIsDropping) {
        this.sharedDatasSvc.pafAlert('Fichier_en_cours_d_import');
        this.fileUpload.nativeElement.value = "";
        return;
      }
      this.pendingFile = file;
       this.onValueChanged();
    }
  }

  onFileSelected(event: any) {
    this.onFilesDropped( event.target.files);
  }

  afterFileUploaded():void {
    this.fileIsDropping=false;
    this.uploadProgress = null;
    this.uploadSub = null;
  }

}
